import { render, staticRenderFns } from "./CmsMultiCol.vue?vue&type=template&id=25b4f6ff&scoped=true"
import script from "./CmsMultiCol.vue?vue&type=script&lang=js"
export * from "./CmsMultiCol.vue?vue&type=script&lang=js"
import style0 from "./CmsMultiCol.vue?vue&type=style&index=0&id=25b4f6ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4f6ff",
  null
  
)

export default component.exports